export const FEED_CONSTANTS = {
  REFRESHING: 'Refreshing...',
  REFRESH_FEED: 'Refresh Feed',
  LOADING: {
    LOADING: 'Loading...',
    LOADING_FEED: 'Loading your personalized feed...',
  },
  LOAD_MORE_POSTS: 'Load More Posts',
  RECOMMENDED: {
    BASED_ON_INTERESTS: 'Recommended based on your interests',
  },
  NO_RECOMMENDATIONS: 'No recommendations yet',
  JUST_NOW: 'Just now',
  MINUTE: 'Min',
  MINUTES: 'Mins',
  HOUR: 'h',
  DAY: 'd',
  WEEK: 'w',
  MONTH: 'm',
  YEAR: 'y',
  AGO: 'ago',
  CREATE_DRAFT_REPLY: 'Reply',
};
